const types = {
	CPA: 1,
	CPL: 2,
	ApprovedRejected: 3,
	WithRestrictedGeo: 4
};

const anyLocale = {
	CPA: 'CPA',
	CPL: 'CPL',
	ApprovedRejected: 'Approved Rejected (Cancellations)',
	WithRestrictedGeo: 'WithRestrictedGeo'
};

const locale = {
	ru: anyLocale,
	uk: anyLocale,
	en: anyLocale,
	de: anyLocale,
	vi: anyLocale,
	th: anyLocale
};

module.exports = {
	enum: types,
	locale: locale
};



// WEBPACK FOOTER //
// ./enums/conversion-types.js